import { Product } from 'modules/contract/types';

export const displayProductModelAndSku = (product: Product) => {
  return (product.model ? `Model: ${product.model} / ` : '') + `SKU #: ${product.sku}`;
};